<app-navbar-style-one></app-navbar-style-one>
<app-navbar-style-two></app-navbar-style-two>
<div class="container">
    <div class="video-container">
     <div class="container text-center">
       <h1>Latest Video Posts</h1>
     </div>
    </div>
   <div class="gallery-container">

     <mat-tab-group>

       <mat-tab *ngFor="let category of videoCategories" [label]="category.name">
        <div align="center" *ngIf="gifLoader">
          <img height="100px" width="100px"
              src="https://medeilpos.blob.core.windows.net/posimage/loading.gif" alt="medeil gif"
              loading="lazy">
         </div>
         <div class="gallery-wrapper mt-2">
           <div *ngFor="let video of getVideosByCategory(category.id)" class="gallery-item">
             <div class="video-card" (click)="updateSeoMetadata(video)">
               <div class="video-preview">
                  <video *ngIf="isDirectVideo(video.videolink)" controls width="100%">
                    <source [src]="video.embedUrl" type="video/mp4">
                    Your browser does not support the video tag.
                  </video>
                  <iframe *ngIf="isEmbed(video.videolink)" [src]="video.embedUrl" width="100%" height="160"
                    frameborder="0" allowfullscreen></iframe>
               </div>
               <div class="video-info">
                 <h2 class="video-title">{{ video.title }}</h2>
                 <p class="video-description">{{ video.description }}</p>
                 <div class="video-meta">
                   <span class="date">{{ video.publishdate | date }}
                   </span>

                 </div>
                 <a (click)="viewPage(video)" class="read-more">..Read More</a>
                 <div class="video-actions">
                    <a [href]="'https://www.facebook.com/sharer/sharer.php?u=' + video.videolink" target="_blank" class="social-btn facebook">
                        <i class="fab fa-facebook-f"></i>
                    </a>
                    <a [href]="'https://twitter.com/intent/tweet?url=' + video.videolink + '&text=' + video.title" target="_blank" class="social-btn twitter">
                      <i class="fa fa-x"></i>
                    </a>
                    <a (click)="copyToClipboard(video.videolink)" class="social-btn instagram">
                      <i class="fab fa-instagram"></i>
                    </a>
                  </div>
               </div>
             </div>
           </div>
         </div>
       </mat-tab>
     </mat-tab-group>
   </div>

   </div>
<app-footer-style-two></app-footer-style-two>